module.exports = __webpack_public_path__ + "static/media/brandmark-coin-bg.d44d6dcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brandmark-coin-bg.png
// module id = 187
// module chunks = 0